export enum Order_Status {
  TO_DO = "TO_DO",
  IN_PROGRESS = "IN_PROGRESS",
  DELIVERED = "DELIVERED",
  DONE = "DONE",
  CANCELLED = "CANCELLED",
}
